<template>
  <div class="filter__item__body">
    <tooltip
      :content="$t('autocaller_v2.webhook.input.disabled')"
      :disabled="!disabled"
      class="d-flex w-100"
      theme="light"
    >
      <i-select v-if="options" :value="value" :label="options.label" :disabled="disabled" @input="input">
        <i-option
          v-if="value"
          :value="options.type"
          :label="options.label"
        />
        <i-option
          v-for="type in filter_items"
          :key="type.type"
          :value="type.type"
          :label="type.label"
        />
      </i-select>
      <i-select v-else :value="value" :clearable="true" :disabled="disabled" @input="input">
        <i-option
          v-for="type in filter_items"
          :key="type.type"
          :value="type.type"
          :label="type.label"
        />
      </i-select>
    </tooltip>
  </div>
</template>

<script>
  import { WebhookService } from '@autocaller_v2/services/WebhookService';
  export default {
    props: {
      value: {
        type: [Number, String],
        default: ''
      },
      disabled: {
        type: [Boolean],
        default: false
      }
    },
    data() {
      return {
        items: [],
        val: this.value,
        filter_items: [],
        types: [
          {
            type: 'call_interrupted',
            label: this.$t('autocaller_v2.webhook.webhook_type.call_interrupted')
          },
          {
            type: 'op_disconnected',
            label: this.$t('autocaller_v2.webhook.webhook_type.op_disconnected')
          },
          {
            type: 'op_active',
            label: this.$t('autocaller_v2.webhook.webhook_type.op_active')
          },
          {
            type: 'op_inactive',
            label: this.$t('autocaller_v2.webhook.webhook_type.op_inactive')
          },
          {
            type: 'call_restored',
            label: this.$t('autocaller_v2.webhook.webhook_type.call_restored')
          },
          {
            type: 'call_started',
            label: this.$t('autocaller_v2.webhook.webhook_type.call_started')
          },
          {
            type: 'call_client_answered',
            label: this.$t('autocaller_v2.webhook.webhook_type.call_client_answered')
          },
          {
            type: 'call_failed',
            label: this.$t('autocaller_v2.webhook.webhook_type.call_failed')
          },
          {
            type: 'call_finished',
            label: this.$t('autocaller_v2.webhook.webhook_type.call_finished')
          },
          {
            type: 'task_success',
            label: this.$t('autocaller_v2.webhook.webhook_type.task_success')
          },
          {
            type: 'task_failed',
            label: this.$t('autocaller_v2.webhook.webhook_type.task_failed')
          },
          {
            type: 'recording_ready',
            label: this.$t('autocaller_v2.webhook.webhook_type.recording_ready')
          },
          {
            type: 'op_deactivating',
            label: this.$t('autocaller_v2.webhook.webhook_type.op_deactivating')
          },
          {
            type: 'call_connected',
            label: this.$t('autocaller_v2.webhook.webhook_type.call_connected')
          },
          {
            type: 'op_connected',
            label: this.$t('autocaller_v2.webhook.webhook_type.op_connected')
          },
          {
            type: 'amd_result',
            label: this.$t('autocaller_v2.webhook.webhook_type.amd_result')
          }
        ]
      }
    },
    computed: {
      options() {
        if(this.value) {
          return this.value ? this.types.filter(item=> item.label==this.val)[0] : null
        }
        return null
      }
    },
    async created() {
      this.items = await WebhookService.getAllItems();
      let filter_i = this.items.data;
      this.filter_items = this.types.filter(function(filter_items) {
        return filter_i.filter(function(types_items) {
          return filter_items.type == types_items.type;
        }).length == 0;
      });
    },
    mounted() {
      if( this.options ) {
        this.input(this.options.type)
      }
    },
    methods: {
      input(val) {
        if(this.options) {
          (val == this.options.type) ? this.$emit('repeated', true) : this.$emit('repeated', false)
        }
        this.$emit('input', val)
      }
    }
  };
</script>
